import { Flex, P, Radio } from '@dnb/eufemia';
import { useId } from 'react';

import { useUrlFilters } from '@/hooks/useUrlFilters';
import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

export const CLASSIFICATION_FILTER_KEY = 'type';

interface Props {
  classifications: string[];
  classificationCount: Record<string, number>;
  allApiCount?: number;
}

export default function TypeFilter({ classifications, classificationCount, allApiCount }: Props) {
  const { updateFilterInURL, getSelectedKeysFromURL } = useUrlFilters();
  const radioGroupName = `api-type-${useId()}`;

  const classificationOptions = classifications.map((type) => ({
    selectedKey: type,
    content: [type],
  }));

  const selectedFilters = getSelectedKeysFromURL(CLASSIFICATION_FILTER_KEY, classificationOptions);
  const selectedValue = selectedFilters[0] || '';

  const handleChange = (value: string) => {
    updateFilterInURL(CLASSIFICATION_FILTER_KEY, [value], classificationOptions);
  };

  return (
    <Flex.Vertical top="small">
      <P modifier="medium" space={{ bottom: 'x-small' }}>
        Type
      </P>
      <Radio.Group
        layout_direction="column"
        name={radioGroupName}
        on_change={({ value }) => value && handleChange(value)}
        value={selectedValue}
      >
        {classifications.map((type) => (
          <Radio
            key={type}
            label={`${capitalizeFirstLetterOfString(type.toLowerCase())} (${
              type === 'all' ? (allApiCount ?? 0) : (classificationCount[type] ?? 0)
            })`}
            size="medium"
            value={type}
          />
        ))}
      </Radio.Group>
    </Flex.Vertical>
  );
}
